import { CONFIG } from '../../../config.js';

const api_url = {
	CONTACTUS: `${CONFIG.EMAIL_API}/send`
}

const dummy = {
	DUMMY: 23
}

export const contactusSettings = {
	api_url,
	dummy
}